// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconHardwareHighQuality_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10.6705 18.0002H8.62254V12.9282H3.59854V18.0002H1.55054V6.57617H3.59854V11.1842H8.62254V6.57617H10.6705V18.0002ZM22.9883 12.1762C22.9883 14.1068 22.4496 15.5628 21.3723 16.5442 20.295 17.5148 18.791 18.0002 16.8603 18.0002H13.6443V6.57617H17.1963C18.3803 6.57617 19.4043 6.78951 20.2683 7.21617 21.1323 7.64284 21.799 8.27217 22.2683 9.10417 22.7483 9.93617 22.9883 10.9602 22.9883 12.1762ZM20.8443 12.2402C20.8443 10.8748 20.5296 9.87217 19.9003 9.23217 19.271 8.59217 18.3696 8.27217 17.1963 8.27217H15.6923V16.2882H16.9243C19.5376 16.2882 20.8443 14.9388 20.8443 12.2402Z" class="svg-bg"/>
</svg>
`;
/**
 * IconHardwareHighQuality is a generated icon component.
 */
let IconHardwareHighQuality = IconHardwareHighQuality_1 = class IconHardwareHighQuality extends IconBaseElement {
    render() {
        return html `${IconHardwareHighQuality_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconHardwareHighQuality.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconHardwareHighQuality = IconHardwareHighQuality_1 = __decorate([
    customElement('zui-icon-hardware-high-quality')
], IconHardwareHighQuality);
export { IconHardwareHighQuality };
